var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('b-button',{attrs:{"disabled":_vm.generatingPdf,"variant":"all"},on:{"click":_vm.generatePdf}},[_vm._v(" Générer le PDF ")]),_c('b-button',{staticClass:"ml-3",attrs:{"disabled":_vm.generatingPdf},on:{"click":_vm.goBack}},[_vm._v(" Retour ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }